import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCousinC.module.scss";

function PageCousinC() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p32", "png");
  const pointer = getImgSet("pointer__cousin", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__04__alt", "png", s.img__a);
  const imgB = getImgSet("bear__05__alt", "png", s.img__b);
  const description = getImgSet("description__p32", "png", s.description);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/cousin/" className={s.back}>
          {back}
        </Link>
        <div className={s.bears}>
          {imgA}
          {imgB}
        </div>
      </div>
      <div className={s.inner}>
        <Link to="/cousin/d" className={cn(s.item, s.item__01)}>
          {item01}
        </Link>
      </div>
      <div className={s.aside_right}>{description}</div>
    </div>
  );
}

export default withLayoutSimple(PageCousinC, false, true, true, true);
